import { createSlice } from '@reduxjs/toolkit';

const initialPhase = {
    id:1,
    phaseName:"Phase 1",
    subject:[],
    startDate:"",
    endDate:"",
    isRevision: false,
}

const  initialCoursePlan = {
    packageId:"",
    type:"",
    phases:[],
    totalPhases:1,
    startDate:"",
    endDate:"",
    subjects:[],
    testSeries:[],
    weekFormat:"weekly"
};

const initialState = {
    phases: {
        phase1: {
            ...initialPhase
        }
    },
    addedChapterCount:[],
    courseSyllabus:[],
    primaryCourseSubjects : [],
    coursePlanState:{
        ...initialCoursePlan
    },
    totalSubjectChapters:[],
    coursePlanResponse:{},
    //coursePlan:{}
    courseDetailsObject: [],
    phaseCount: 1,
    checkWeek: false,
    // disabledDatesList: [],
}


const createCoursePlanStates = createSlice({
    name: 'createCoursePlanStates',
    initialState: { ...initialState },
    reducers: {
        setPhaseData :(state = {}, action = {}) => {
           
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setchapterCount :(state = {}, action = {}) => {
           
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setCourseSyllabus :(state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setCoursePlanStates: (state, action) => {
            // console.log('::::::::::In SET COURSE PLAN STATES:::::::', action.payload)
            state =  { ...state, ...action.payload };
            return state;
        },
        setChaptersSubject: (state, action) => {
            state =  { ...state, ...action.payload };
            return state;
        },
        setCoursePlanResponse: (state, action) => {
            state =  { ...state, ...action.payload };
            return state;
        },
        setGetCourseApiStates: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setPrimaryCourseSubjects: (state, action) => {
            state.primaryCourseSubjects = action.payload
        },
        getPrimaryCourseSubjects: (state, action) => {
            return state.primaryCourseSubjects
        },
        setCourseDetailsObject: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        setPhaseCount: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },
        // setPreviousPhaseData: (state = {}, action = {}) => {
        //     const { payload = {} } = action;
        //     return { ...state, ...payload };
        // },
        setCheckWeek: (state = {}, action = {}) => {
            const { payload = {} } = action;
            return { ...state, ...payload };
        },    
        
    }
})
const { actions, reducer } = createCoursePlanStates;
const createCoursePlanStatesAction = actions;
export { createCoursePlanStatesAction };
export default reducer;